export enum EntryDataDataTest {
    CoAuthorsSelect = 'EntryDataDataTest_CoAuthorsSelect',
    CoAuthorsSave = 'EntryDataDataTest_CoAuthorsSave',
    CreationDateSelect = 'EntryDataDataTest_CreationDateSelect',
    VisitDateSelect = 'EntryDataDataTest_VisitDateSelect',
    DateSave = 'EntryDataDataTest_DateSave',
    DoctorSelect = 'EntryDataDataTest_DoctorSelect',
    DoctorSave = 'EntryDataDataTest_DoctorSave',
}
